<template>
	<div class="page">
		<!-- attendance filters -->
		<div class="mb-2">
			<span>عرض الامتحانات حسب:</span>
			<v-radio-group
				v-model="isAttended"
				row
				dense
				hide-details
				class="attendance-radio mt-1 pt-0"
			>
				<v-radio :value="null" label="الكل" class="black--text">الكل</v-radio>
				<v-radio :value="true" label="التي حضرها" class="black--text">التي حضرها</v-radio>
				<v-radio :value="false" label="التي غاب عنها" class="black--text">التي غاب عنها</v-radio>
			</v-radio-group>
		</div>

		<!-- subjects -->
		<div>
			<div class="mb-2">المحاور</div>

			<!-- data -->
			<v-card
				v-for="(subject, index) in allSubjects"
				:key="index"
				outlined
				:class="`color-${index + 1 % 6}-opacity`"
				class="subject-card mb-3"
			>
				<v-card-title class="primary--text text-h6 font-weight-regular px-3 py-2">
					{{subject.name}}
				</v-card-title>
				<v-divider class="mx-3"/>
				<v-card-text class="px-3 py-2">
					<v-card
						v-for="(child, i) in subject.children"
						:key="i"
						outlined
						class="subject-card mb-2"
					>
						<v-card-title class="text-h6 font-weight-regular py-1 px-2">
							{{child.name}}
						</v-card-title>
						<v-card-text class="px-2">
							<v-row dense>
								<!-- attendance -->
								<v-col
									cols="2"
									class="d-flex flex-column justify-center"
								>
									<div class="mb-1">التفقد</div>
									<div class="black--text">
										<v-icon
											v-if="child.attendance !== null"
											size="18"
											:color="child.attendance ? 'green' : 'error'"
										>
											{{ child.attendance ? 'mdi-checkbox-marked-circle-outline' : 'mdi-close-circle-outline'}}
										</v-icon>
										<span v-else>-</span>
									</div>
								</v-col>

								<!-- date -->
								<v-col
									cols="3"
									class="d-flex flex-column justify-center"
								>
									<div class="mb-1">التاريخ</div>
									<div class="black--text">{{child.date || '-'}}</div>
								</v-col>

								<!-- mark -->
								<v-col
									cols="3"
									class="d-flex flex-column justify-center"
								>
									<div class="mb-1">العلامة</div>
									<div class="black--text">{{child.mark || '-'}}</div>
								</v-col>

								<!-- percent -->
								<v-col
									cols="2"
									class="d-flex flex-column justify-center"
								>
									<div class="mb-1">النسبة</div>
									<div class="black--text">{{child.percent || '-'}}</div>
								</v-col>

								<!-- grade -->
								<v-col
									cols="2"
									class="d-flex flex-column justify-center"
								>
									<div class="mb-1">الترميز</div>
									<div class="black--text">{{child.grade || '-'}}</div>
								</v-col>

								<!-- notes -->
								<v-col
									cols="12"
									class="d-flex flex-column justify-center"
								>
									<div class="mb-1">ملاحظات</div>
									<div class="black--text">{{child.notes || '-'}}</div>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-card-text>
			</v-card>

			<div v-if="!allSubjects.length" class="text-center mt-4">
				لا يوجد محاور
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LanguageConcept',

	data() {
		return {
			isAttended: null,
			subjects: [],
		}
	},

	computed: {
		allSubjects() {
			let items = this.subjects;
			items = items.map(subject => ({
				...subject,
				children: subject.children.filter(child => {
					return this.isAttended !== null ? child.attendance === this.isAttended : true;
				})
			})).filter(c => c.children.length > 0)
			
			return items
		}
	},

	created() {
		this.$eventBus.$emit('page-loader', true);
		this.$store.dispatch('languages/fetchMarks', {
			conceptId: this.$route.params.conceptId
		}).then(data => {
			this.subjects = data.map(c => ({
				id: c.id,
				name: c.topic,
				children: c.marks.map(e => ({
					name: e.topic.name,
					attendance: e.isAbsent !== null ? !e.isAbsent : null,
					date: e.date ? e.date.slice(0, 10) : null,
					mark: e.maxMark ? `${e.mark}/${e.maxMark}` : null,
					percent: e.maxMark ? `${+(e.mark / e.maxMark * 100).toFixed(2)}%` : null,
					grade: e.scale,
					notes: e.notes,
				}))
			}));
		}).finally(() => {
			this.$eventBus.$emit('page-loader', false);
		});
	}
}
</script>

<style lang="scss" scoped>
.color {
	&-1-opacity, &-2-opacity,&-3-opacity,&-4-opacity,&-5-opacity,&-6-opacity { color: black; }
	&-1-opacity { background-color: #3570B622; }
	&-2-opacity { background-color: #866DF222; }
	&-3-opacity { background-color: #18A50322; }
	&-4-opacity { background-color: #FC5E3322; }
	&-5-opacity { background-color: #FA0A7822; }
	&-6-opacity { background-color: #7A426922; }
}
.subject-card {
	border-radius: 8px;
}
</style>
<style lang="scss">
.attendance-radio {
	.v-label { color: black; font-size: 1rem; }
}
</style>